





















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { EntityCardStructure } from '../includes/types'

@Component({})
export default class SelectEntity extends Vue {
  @Prop({ type: Object }) entity!: EntityCardStructure
}
